import React from "react";
import { SERVICES } from "@/lib/mockData";
import { Search, Rocket, PenTool, LineChart } from "lucide-react";

const iconMap = { search: Search, rocket: Rocket, "pen-tool": PenTool, "line-chart": LineChart };

const Services = () => {
  return (
    <section id="services" className="relative">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-24 lg:py-32">
        <div className="max-w-2xl">
          <p className="text-xs uppercase tracking-[0.2em] text-blue-400 mb-3">
            What we do
          </p>
          <h2
            className="text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tighter text-zinc-50"
            data-testid="services-heading"
          >
            An operating system for creator marketing.
          </h2>
          <p className="mt-4 text-zinc-400">
            From sourcing the right creator to the final ROI report — we run every layer of the
            campaign so your team can focus on the brand.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-5 lg:gap-6">
          {SERVICES.map((s) => {
            const Icon = iconMap[s.icon] || Search;
            return (
              <div
                key={s.title}
                className="group relative rounded-2xl border border-white/8 bg-white/[0.02] p-7 lg:p-8 transition-all duration-300 hover:border-blue-500/30 hover:bg-blue-500/[0.03] hover:-translate-y-1"
                data-testid={`service-card-${s.title.toLowerCase().replace(/\s/g, "-")}`}
              >
                <div className="h-11 w-11 rounded-lg bg-blue-600/10 border border-blue-500/20 flex items-center justify-center mb-5 group-hover:bg-blue-600/20 transition-colors">
                  <Icon className="h-5 w-5 text-blue-400" />
                </div>
                <h3 className="text-xl font-semibold text-zinc-50 tracking-tight">{s.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-zinc-400">{s.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
